var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: -69,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 37,
    height: 37
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.01,32.98c.16-.59.31-1.13.46-1.68.33-1.2.66-2.41.99-3.61.05-.18.03-.32-.07-.47-.67-1.03-1.23-2.11-1.64-3.27-.54-1.52-.84-3.09-.88-4.71-.15-6.17,3.42-11.52,8.59-13.99,1.81-.86,3.73-1.34,5.73-1.44,7.35-.36,13.57,4.59,15.29,11.19.53,2.04.66,4.11.31,6.19-.81,4.74-3.31,8.32-7.44,10.76-1.97,1.16-4.12,1.79-6.4,1.94-3.18.21-6.14-.52-8.87-2.16-.47-.28-.29-.25-.81-.11-1.68.44-3.36.88-5.04,1.32-.06.02-.12.03-.23.05ZM14.02,10.5s0-.01,0-.02c-.15,0-.3,0-.45,0-.44,0-.82.14-1.14.44-1.43,1.35-1.96,3-1.6,4.92.22,1.16.74,2.2,1.39,3.17.72,1.07,1.49,2.09,2.36,3.04,1.21,1.32,2.54,2.5,4.07,3.43,1.44.88,3.01,1.47,4.62,1.91.82.23,1.67.23,2.5.06,1.02-.21,1.89-.74,2.61-1.5.13-.13.24-.29.32-.46.28-.66.43-1.35.4-2.07,0-.22-.11-.37-.29-.47-.06-.03-.12-.07-.19-.1-1.05-.51-2.1-1.02-3.16-1.53-.18-.09-.37-.16-.57-.22-.39-.12-.57-.04-.83.28-.47.59-.94,1.18-1.42,1.76-.26.31-.48.36-.85.2-.75-.32-1.49-.66-2.18-1.09-1.68-1.05-2.98-2.47-4.01-4.15-.34-.56-.32-.69.13-1.18.4-.45.82-.89,1.06-1.45.11-.25.13-.49.02-.74-.48-1.15-.96-2.31-1.44-3.46-.07-.17-.17-.33-.27-.48-.13-.19-.31-.28-.54-.28-.19,0-.37,0-.56,0ZM1.66,37.28c.14-.03.24-.05.33-.07,3-.79,6-1.57,8.99-2.37.19-.05.35-.04.53.06,2.27,1.2,4.7,1.88,7.26,2.04,1.59.1,3.17.01,4.73-.32,4.41-.93,8.02-3.16,10.77-6.72,2.81-3.64,4.03-7.8,3.72-12.39-.15-2.31-.74-4.51-1.76-6.58-1.9-3.84-4.79-6.69-8.66-8.52-3.18-1.5-6.54-1.97-10.03-1.53-1.97.25-3.84.82-5.62,1.71-3.69,1.85-6.46,4.63-8.28,8.33-1.57,3.19-2.11,6.56-1.7,10.08.28,2.37,1,4.6,2.17,6.68.08.15.1.28.05.45-.67,2.43-1.34,4.87-2,7.3-.16.6-.33,1.19-.5,1.84Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.cffdc91b9af131f225d71204a76b3a87.svg";
export { ForwardRef as ReactComponent };